'use strict';
angular.module('schoolLinqApp').factory('customerService', [
	'$http',
	function ($http) {
		const endpoint = '/api/customers';

		function getCustomer(id) {
			return $http.get(endpoint + '/' + id);
		}

		function getCustomers(siteId) {
			return $http.get(endpoint, { params: { siteId: siteId } });
		}

		function addCustomer(customer) {
			return $http.post(endpoint, customer);
		}

		function updateCustomer(customer) {
			return $http.put(endpoint + '/' + customer.Id, customer);
		}

		function deleteCustomer(customerId) {
			return $http.delete(endpoint + '/' + customerId, customerId);
		}

		function getCustomerStatuses() {
			return [
				{ Description: 'No Filter', Status: '' },
				{ Description: 'Active', Status: true },
				{ Description: 'Inactive', Status: false },
			];
		}

		return {
			getCustomer: getCustomer,
			getCustomers: getCustomers,
			addCustomer: addCustomer,
			getCustomerStatuses: getCustomerStatuses,
			updateCustomer: updateCustomer,
			deleteCustomer: deleteCustomer,
		};
	},
]);
